import AboutSection from '../components/AboutSection';
import BookPage from '../components/common/BookPage';

const AboutPage = () => {
  return (
    <BookPage
      eyebrow="Me"
      title="If you really want to know."
      intro="I'm not really sure what to tell you, but... here's some stuff."
    >
      <AboutSection />
    </BookPage>
  );
};

export default AboutPage;
